import { CalendarSchedule, Calendars } from 'components/CalendarSchedule';
import { Routes } from 'constants/pages';
import { SignUpTemplate } from 'layouts/SignUpTemplate';
import { Hi } from 'layouts/SignUpTemplate/components/Hi';
import * as React from 'react';
import { Link } from 'react-router-dom';

export const Welcome: React.FC = () => {
  return (
    <SignUpTemplate>
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
        <div className="w-full max-w-[496px] mt-16 justify-self-center md:justify-self-end">
          <div className="space-y-3">
            <Hi />
            <h1 className="font-bold">Last step, book a demo!</h1>
            <h4 className="font-medium">
              One of our sales representative will give you a tour of BlueCargo.
            </h4>
          </div>
          <div className="text-blue-900 mt-8">
            <Link to={Routes.Home}>Skip and continue to BlueCargo without a demo</Link>
          </div>
        </div>
        <CalendarSchedule url={Calendars.ScheduleDemo} />
      </div>
    </SignUpTemplate>
  );
};
